module.exports = __webpack_public_path__ + "img/img_bonus.d4750178.png";